import { Flex } from "@chakra-ui/react";
import { Button, Input } from "@sgi/gravity";
import { ChangeEvent, KeyboardEvent, useCallback, useState } from "react";
import { useVerifyEmailProxy } from "../Custom Hooks/useVerifyEmailProxy";

export default function VerifyEmail() {
  const [verificationCode, setVerificationCode] = useState('');
  const {
    sendCodeAction, verifyCodeAction, sendNewCodeAction, verificationError
  } = useVerifyEmailProxy({ verificationCode });

  const onVerifyChange = useCallback((e: ChangeEvent<HTMLInputElement>) => setVerificationCode(e.target.value), []);
  const onVerificationCodeKeyDown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") verifyCodeAction.act();
  }, [verifyCodeAction]);

  return (
    <Flex direction="column" maxW={468} mx="auto" data-testid="verify-email-page-test">
      {sendNewCodeAction.visible ? (
        <Button
          my={1}
          isFullWidth
          data-testid="send-new-code-button-test"
          disabled={sendNewCodeAction.disabled}
          onClick={sendNewCodeAction.act}
        >
          Send A New Code
        </Button>
      ) : (
        <Button
          my={1}
          isFullWidth
          data-testid="send-code-button-test"
          disabled={sendCodeAction.disabled}
          onClick={sendCodeAction.act}
        >
          Send Code
        </Button>
      )}
      {verifyCodeAction.visible && (
        <>
          <Input
            autoFocus
            my={1}
            label="Verification code"
            name="Verification"
            id="verify-code-field"
            type="text"
            style={{ backgroundColor: "white" }}
            onChange={onVerifyChange}
            onKeyDown={onVerificationCodeKeyDown}
            placeholder="Enter Verification code from email"
            error={verificationError}
            data-testid="code-input"
            isRequired={true}
            value={verificationCode}
            maxLength={6}
            pattern="\\d{6}"
          />
          <Button
            my={1}
            isFullWidth
            data-testid="verify-code-button-test"
            disabled={verifyCodeAction.disabled}
            onClick={verifyCodeAction.act}
          >
            Verify Code
          </Button>
        </>
      )}
    </Flex>
  );
}